module.exports = __WEBPACK_EXTERNAL_MODULE_329__;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 329
// module chunks = 0